import { useEffect, useState } from "react";
import { PRODUCT } from "@/constants/testIds";

function pad(n) { return n < 10 ? `0${n}` : `${n}`; }

export default function Countdown({ endsAt, className = "" }) {
  const [now, setNow] = useState(Date.now());
  useEffect(() => {
    const t = setInterval(() => setNow(Date.now()), 1000);
    return () => clearInterval(t);
  }, []);
  if (!endsAt) return null;
  const end = new Date(endsAt).getTime();
  const diff = Math.max(0, end - now);
  const ended = diff === 0;
  const totalHours = Math.floor(diff / 3.6e6);
  const days = Math.floor(totalHours / 24);
  const hours = totalHours % 24;
  const mins = Math.floor((diff % 3.6e6) / 6e4);
  const secs = Math.floor((diff % 6e4) / 1000);
  const urgent = !ended && diff < 3.6e6; // <1h
  return (
    <div
      data-testid={PRODUCT.countdown}
      className={`inline-flex items-center gap-2 font-mono text-xs uppercase tracking-[0.2em] border border-white/20 px-3 py-1.5 ${urgent ? "urgent-pulse border-[#FF3366] text-[#FF3366]" : "text-white"} ${className}`}
    >
      <span className="text-[10px] text-white/50">{ended ? "DROP" : "ENDS"}</span>
      {ended ? (
        <span>ENDED</span>
      ) : (
        <span>
          {days > 0 && `${days}d `}
          {pad(hours)}:{pad(mins)}:{pad(secs)}
        </span>
      )}
    </div>
  );
}
